import { useSelector } from "react-redux";

import { Namespace, useTranslate } from "localization";
import { Tooltip, Typography } from "minimum-ui/core";
import { color } from "minimum-ui/tokens";
import { dateDistance } from "pages/CollectionStatus/AutomatedCollection/utils";

import { userSelectors } from "store/user/userSelectors";

import Date from "./Date";

const LastRefreshedConsolidatedEmissions = () => {
  const { translate } = useTranslate(Namespace.DEFAULT);
  const currentOrg = useSelector(userSelectors.currentOrganisation);
  return (
    <>
      {currentOrg?.consolidatedEmissionsLastRefreshed && (
        <Tooltip
          title={
            <>
              {translate("refreshedOn", {
                namespace: Namespace.DEFAULT,
              })}
              <Date
                formatString={translate("dateTimeFormat", {
                  namespace: Namespace.DEFAULT,
                })}
                value={currentOrg.consolidatedEmissionsLastRefreshed}
              />
            </>
          }
          placement="right"
        >
          <Typography variant="bodySmall" color={color.foreground.muted}>
            {translate("lastUpdated", {
              refreshedTime: dateDistance(
                currentOrg.consolidatedEmissionsLastRefreshed,
                undefined,
                false
              ),
            })}
          </Typography>
        </Tooltip>
      )}
    </>
  );
};

export default LastRefreshedConsolidatedEmissions;
